import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import checkSample from "../../assets/images/check_sample.png";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "../../components/ui/dialog";

interface BankVerificationHelpModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

// Explains how to locate the routing/account number on a check, opened from the
// info icons next to those fields in BankVerificationModal.
function BankVerificationHelpModal({ open, onOpenChange }: BankVerificationHelpModalProperties) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false} className="max-w-2xl gap-0 overflow-hidden p-0">
        <div className="bg-primary text-primary-foreground flex items-center justify-between border-b px-4 py-2">
          <DialogTitle className="text-primary-foreground text-sm font-semibold">
            {t("stipulations.bankVerification.title")}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t("stipulations.bankVerification.help.description")}
          </DialogDescription>
          <DialogClose className="text-primary-foreground/80 hover:text-primary-foreground p-0.5 transition-colors">
            <X className="size-4.5" />
            <span className="sr-only">{t("stipulations.bankVerification.close")}</span>
          </DialogClose>
        </div>

        <div className="p-6">
          <div className="border-border bg-muted rounded-md border p-6">
            <p className="text-foreground text-center text-sm font-semibold">
              {t("stipulations.bankVerification.help.checksHeading")}
            </p>

            <img
              src={checkSample}
              alt={t("stipulations.bankVerification.help.checkAlt")}
              className="mx-auto my-4 max-w-md"
            />

            <div className="text-foreground text-sm">
              <p>{t("stipulations.bankVerification.help.noChecksHeading")}</p>
              <ul className="list-disc space-y-1 pl-5">
                <li>{t("stipulations.bankVerification.help.noChecksBullet1")}</li>
                <li>{t("stipulations.bankVerification.help.noChecksBullet2")}</li>
                <li>{t("stipulations.bankVerification.help.noChecksBullet3")}</li>
                <li>{t("stipulations.bankVerification.help.noChecksBullet4")}</li>
              </ul>
            </div>
          </div>
        </div>

        <DialogFooter className="px-6 pb-6 sm:justify-center">
          <Button type="button" className="px-8" onClick={() => onOpenChange(false)}>
            {t("stipulations.bankVerification.help.dismiss")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default BankVerificationHelpModal;
